import { EnvironmentName } from './shared/types/enums/environmentName';

export const getEnvironmentName = (env?: string): EnvironmentName => {
  const url = new URL(env || document.baseURI);
  if (url.hostname === 'localhost') return 'local';
  if (url.hostname === 'kind-hill-02fda0b03.2.azurestaticapps.net' && url.protocol === 'https:') return 'dev';
  if (url.hostname === 'internutleie-test.tsmaskin.no' && url.protocol === 'https:') return 'test';
  if (url.hostname === 'internutleie.tsmaskin.no' && url.protocol === 'https:') return 'prod';
  return '';
};
